import { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import SpinerLoader from "../../../components/SpinerLoader";
import NoData from "../../../components/NoData";
import AlertClaimDetail from "../components/AlertClaimDetail";
import AlertsDAD from "../components/AlertsDAD";
import { AlertCard } from '../types';
import { getAlertsStates } from "../api/getAlertsStates";
import { useAlertSurvey } from "../api/getAlertSurvey";
import { useAlertClaim } from "../api/getAlertClaim";
import AlertMessage from "../../../components/AlertMessage"
import { useAlert } from "../../../hooks/useAlert";
import { ApiErrorResponse } from "../../../types/ApiErrorResponse";
import AlertSurveyDetail from "../components/AlertSurveyDetail";
import { useSearchParams } from "react-router-dom";

export default function Alerts() {
    const [searchParams, setSearchParams] = useSearchParams();
    const request = searchParams.get('request');
    const survey = searchParams.get('survey');
    
    const [alertsData, setAlertsData] = useState<AlertCard[]>([]);
    const [isLoadingUrgencies, setIsLoadingUrgencies] = useState<boolean>(true);
    const [selectedSurveyId, setSelectedSurveyId] = useState<number | null>(null)
    const [selectedClaimId, setSelectedClaimId] = useState<number | null>(null)
    const [messageError, setMessageError] = useState<string | undefined>('');

    const { data: alertSurvey, isLoading: isLoadingSurvey } = useAlertSurvey({ surveyId: selectedSurveyId });
    const { data: claim, isLoading: isLoadingClaim } = useAlertClaim({ claimId: selectedClaimId });

    const { alert, hideAlert, isVisible } = useAlert({ fromLocation: true });

    const fetchGetAlertsStates = async () => {
        getAlertsStates().then(data => {
            setAlertsData(data);
        }).catch(error => {
            const fetchError = error as ApiErrorResponse;
            setMessageError(fetchError.message);
        }).finally(() => {
            setIsLoadingUrgencies(false);
        });

    }
    const handleGoBack = async (isUpdated: boolean) => {
        if (isUpdated) {
            await fetchGetAlertsStates();
        }
        setSearchParams({});

        setSelectedSurveyId(null);
        setSelectedClaimId(null)
    };

    useEffect(() => {
        fetchGetAlertsStates();
    },[]);

    useEffect(() => {
        if (!request)
            return;

        setSelectedClaimId(parseInt(request));
    }, [request])

    useEffect(() => {
        if (!survey)
            return;

        setSelectedSurveyId(parseInt(survey));
    }, [survey])

    return (
        <>
            <Row>
                <Col className="text-center" xs={12} md={12}>
                    {isVisible && (
                        <AlertMessage
                            message={alert!.message}
                            type={alert!.type}
                            onClose={hideAlert}
                        />
                    )}
                </Col>
            </Row>

            {alertSurvey ? <AlertSurveyDetail survey={alertSurvey} onGoBackClick={handleGoBack} /> :
                claim ? <AlertClaimDetail claim={claim} onGoBackClick={handleGoBack} /> :
                    
                isLoadingUrgencies || isLoadingSurvey || isLoadingClaim ? <SpinerLoader /> :
                    alertsData?.length ?                            
                        <AlertsDAD urgenciesStates={alertsData} 
                            onSurveyClick={(surveyId: number) => setSelectedSurveyId(surveyId)}
                            onClaimClick={(claimId: number) => setSelectedClaimId(claimId)}
                        />
                        : <NoData message={messageError} />                       
            }
        </>
    );
}

